import Box from '@classify/react-core-components/Box';
import PersonIcon from '@mui/icons-material/Person';

interface Props {
  isSmaller?: boolean;
}

export default function VisitorAvatar({ isSmaller }: Props) {
  const size = isSmaller ? 32 : 40;
  return (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: 'content.highlight.firstLevel.background',
        borderRadius: '50%',
        display: 'grid',
        alignItems: 'center',
        justifyItems: 'center',
        color: 'text.primary',
      }}
    >
      <PersonIcon />
    </Box>
  );
}
